export default "__VITE_ASSET__CBCyz6Gn__"